<template>
    <v-container class="py-8">
        <v-card>
             <v-subheader><h2>Users Assigned to me</h2></v-subheader>
            

            <v-text-field
            class='ma-4'
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      
                  <v-data-table
                  :loading='loading'
                :headers="headers"
                :items="myUsers"
                :search="search"
                >
                
                  <template v-slot:item.info.email="{ item }">
                        <a @click='goTo(item.info.email)'>{{item.info.email}}</a>
                        </template>

                 <template v-slot:item.plan="{ item }">
                        {{ formatPlan(item.plan) }}
                        </template>
                 <template v-slot:item.familyNumber="{ item }">
                        {{ item.familyHistory.length }}
                        </template>
                        <template v-slot:item.action="{ item }">

                             <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Transfer user
        </v-btn>
      
      </template>
      <v-list>
        <v-list-item style='cursor: pointer;'
          v-for="(admin, index) in admins"
          :key="index"
        >
          <v-list-item-title  @click='transferUser(item,admin)'>{{ admin.email }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>


                          
                        </template>
                </v-data-table>
           
        </v-card>
        </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { postReq } from '../helper/firestore'
export default {
    components: {
        
    },
    data() {
        return {
            loading : true,
             search: '',
            myUsers : [],
            headers: [
                { text: 'User Email', value: 'info.email' },
                { text: 'Name', value: 'info.name' },
               { text: 'Questionnaire Completed?', value: 'complete' },
               { text: 'Plan', value: 'plan' },
               { text: "Family Members", value: 'familyNumber'},
               {text : "Action",value: "action"}
              
            ],
        }
    },
    methods: {
        transferUser(user,item){
            console.log(user)
            console.log(item);
              postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/comment/transferUsertoGC', { uid : user.uid, currentGc : this.user.uid, currentGcEmail : this.user.email, gcID : item.uid, gcEmail : item.email}, result => {
                if (result.status !== 200) { return }
                this.myUsers = result.data;
                this.loading = false;
            })
        },
        goTo(route){
            this.$router.push("/user/email/"+ route);
        },
        formatPlan(planName){
            switch (planName){
                case "p1": 
                return "MY GENETIC TRUST COMPLETE";
                case "p1_couple":
                return "MY GENETIC TRUST COMPLETE COUPLE PLAN"
                case "p2": 
                return "MY GENETIC TRUST CONCIERGE";
                case "p2_couple":
                return "MY GENETIC TRUST CONCIERGE COUPLE PLAN"
            }
        }

    },


    mounted() {
            
             postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/patients/getmyusers', { gcid: this.user.uid }, result => {
                if (result.status !== 200) { return }
                this.myUsers = result.data;
                this.loading = false;
            })


    },
    computed: {
        ...mapFields([
            'admins',
            'myTasks',
            'user',
            'snackBarshow',
            'snackBarType',
            'snackBarmessage',
            'overlay'
        ]),
    }
}
</script>

<style>

</style>
